module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "epub:type": "pagebreak",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2022 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2022")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("31 30 29 28 27 26 25 24 23 22     1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-82146-7 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-82245-7 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226822457.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226822457.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Kuklick, Bruce, 1941- author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Fascism comes to America : a century of obsession in politics and culture / Bruce Kuklick.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : The University of Chicago Press, 2022. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCCN")]), _vm._v(" 2022012517 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226821467 (cloth) | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226822457 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCSH")]), _vm._v(": Language and languages—Political aspects. | Fascism—United States. | United States—Politics and government—20th century. | United States—Politics and government—21st century.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("P")]), _vm._v("119.32."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("U")]), _vm._v("6 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("K")]), _vm._v("83 2022 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DDC")]), _vm._v(" 306.44—dc23/eng/20220316")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2022012517",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022012517")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0dd492c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kuklick-0004.vue
// module id = 63
// module chunks = 0